import type { CountriesAlpha2, Currency } from '@sequencehq/api'
import {
  isGoCardlessSupportedCurrency,
  isGoCardlessSupportedEndCustomerCountry
} from 'Integrations/integrationsConfig/goCardless/utils'
import { match } from 'ts-pattern'
import { EXCLUSIVE_PAYMENT_PROVIDER_MESSAGE } from 'Integrations/constants'
import {
  GOCARDLESS_UNSUPPORTED_CURRENCY_MESSAGE,
  GOCARDLESS_UNSUPPORTED_COUNTRY_MESSAGE,
  GOCARDLESS_NO_CUSTOMER_MESSAGE,
  GOCARDLESS_NO_PRODUCTS_MESSAGE
} from 'Integrations/integrationsConfig/goCardless/constants'

type GetGoCardlessDisabledReasonArgs = {
  otherProviderActive: boolean
  currency?: Currency
  country?: CountriesAlpha2
  hasCustomer: boolean
  hasProducts: boolean
}

export const getGoCardlessDisabledReason = (
  args: GetGoCardlessDisabledReasonArgs
): string | null => {
  const isCurrencySupported = args.currency
    ? isGoCardlessSupportedCurrency(args.currency)
    : true
  const isCountrySupported = args.country
    ? isGoCardlessSupportedEndCustomerCountry(args.country)
    : true

  return match({
    hasCustomer: args.hasCustomer,
    hasProducts: args.hasProducts,
    otherProviderActive: args.otherProviderActive,
    isCurrencySupported,
    isCountrySupported
  })
    .with({ hasCustomer: false }, () => GOCARDLESS_NO_CUSTOMER_MESSAGE)
    .with(
      { isCountrySupported: false },
      () => GOCARDLESS_UNSUPPORTED_COUNTRY_MESSAGE
    )
    .with({ hasProducts: false }, () => GOCARDLESS_NO_PRODUCTS_MESSAGE)
    .with(
      { otherProviderActive: true },
      () => EXCLUSIVE_PAYMENT_PROVIDER_MESSAGE
    )
    .with(
      { isCurrencySupported: false },
      () => GOCARDLESS_UNSUPPORTED_CURRENCY_MESSAGE
    )
    .otherwise(() => null)
}
